import * as yup from "yup";

export const AdvertiserImageBlobValidation = yup.mixed()
    .test(
        'is-image',
        'Файл не является изображением',
        (value) => {
            if (!value) return false;
            if (!(value instanceof Blob)) return false;
            return value.type.startsWith('image/');
        }
    );

export const isValidJSONFormat = (str: string): boolean => {
    const regex = /^[\],:{}\s]*$/;
    return regex.test(
        str.replace(/\\["\\\/bfnrtu]/g, '@')
            .replace(/"[^"\\\n\r]*"|\d+([\.]\d+)?/g, ']')
            .replace(/(?:^|:|,)(?:\s*\[)+/g, '')
    );
};

export const validationEmail = async (str: string) => {
    try {
        const schema = yup
        .string()
        .required("Incorect email")
        .email("Incorect email")

        await schema.validate(str);
        return true
    } catch (error) {
        return false
    }
}

export function ValidateTextFields(values: {[key: string]: string}, langs: any){
    
    let error = false
    if(typeof values === 'object'){

        if(!langs.length) error = true

        langs?.map((ln: any) => {
            if(!values[ln.key] || !values[ln.key].length) error = true
        })
    }else error = true

    return !error
}

export function validationCourse(form: any, langs: any){
    let error: string | boolean = false

    // ### Main
    if(!form.image) error = "courses.course_image_error"
    if(!ValidateTextFields(form.name, langs)) error = "courses.course_name_error"
    if(!ValidateTextFields(form.description, langs)) error = "courses.course_description_error"
    if(!form.price && form.active_price) error = "courses.course_price_error"
    if(!form.discount && form.active_discount) error = "courses.course_discount_error"
    if(!form.date) error = "courses.course_date_error"
    if(!form.valid_date && form.active_valid_date) error = "courses.course_until_error"
    if(!ValidateTextFields(form.card_name, langs) && form.active_card_name) error = "courses.course_name_card_error"
    if(!ValidateTextFields(form.card_description, langs) && form.active_card_description) error = "courses.course_description_card_error"

    // ### Modules/Lessons

    form?.modules?.forEach((module: any, index: number) => {
        if(!ValidateTextFields(module.name, langs)) error = `Please fill in the name of module №${index+1}`
        if(!module.lessons?.length) error = `Please add lessons to the module №${index+1}`
        module.lessons?.forEach((lesson: any, lesIndex: number) => {
            console.log(lesson.name);
            if(!ValidateTextFields(lesson.name, langs)) error = `Please fill in the lesson name №${lesIndex+1} in module №${index+1}`
        })
    })



    return error
}

export function validationBlog(form: any, langs: any){
    let error: string | boolean = false

    // ### Main
    if(!form.image) error = "blog.course_image_error"
    if(!ValidateTextFields(form.title, langs)) error = "blog.blog_title_error"
    if(!ValidateTextFields(form.body, langs)) error = "blog.blog_body_error"
    if(!ValidateTextFields(form.card_title, langs) && form.active_card_title) error = "blog.blog_card_title_error"
    if(!ValidateTextFields(form.card_body, langs) && form.active_card_body) error = "blog.blog_card_body_error"
    if(!form.slug) error = "blog.blog_slug_error"

    return error
}